import { pageDefinition } from 'site-modules/shared/pages/page';
import { getPageOptions } from 'site-modules/editorial/pages/top-rated/top-rated-definition';
import { getTopRatedIndexContentPath } from 'site-modules/shared/utils/top-rated/content-path';
import { TopRated } from './top-rated';

const pages = new Map();
export default ({ year, isDefaultYear, chunkName }) => {
  const key = getTopRatedIndexContentPath(year);
  let page = pages.get(key);
  if (!page) {
    page = pageDefinition(getPageOptions({ year, isDefaultYear, pageTemplate: TopRated, chunkName }));
    pages.set(key, page);
  }
  return page;
};
